import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material'
import { PumpaddeditComponent } from './pumpaddedit/pumpaddedit.component';
import { TransformerManagerService } from 'src/app/services/transformerManager.service';
import { PumpService } from '../services/pump.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationDailogComponent } from 'src/app/confirmation-dailog/confirmation-dailog.component';

@Component({
  selector: 'app-pumpmanager',
  templateUrl: './pumpmanager.component.html',
  styleUrls: ['./pumpmanager.component.scss']
})
export class PumpmanagerComponent implements OnInit {

  displayedColumns: string[] = ['serialnumber','sitename', 'deviceId', 'actions', 'state'];
  dataSource;
  deviceMaster: any;
  roleID = JSON.parse(localStorage.getItem('userData')).roleid;

  @ViewChild(MatPaginator, {static:true}) paginator: MatPaginator;
  @ViewChild(MatSort,  {static:true}) sort: MatSort;

  constructor(private matDialog: MatDialog, private transformerMangSer: TransformerManagerService,private PumpService:PumpService, private ngxLoader: NgxUiLoaderService) {}

  ngOnInit() {
   this.getpumpdata();
   console.log(JSON.parse(localStorage.getItem('userData')));

  }

getpumpdata()
{
  this.ngxLoader.start();
  this.PumpService.getPumpData(JSON.parse(localStorage.getItem('userData')).roleid,JSON.parse(localStorage.getItem('userData')).userid,'transformerManager').subscribe((response:any) => {
    console.log("response data for all pump",response)
    if(response && response.code === '1')
    {
      this.ngxLoader.stop();
      console.log(response);
      this.dataSource =  new MatTableDataSource(response.data);;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    else{
      this.ngxLoader.stop();
    }

  })
}


  editData(serialnumber: string) {
    this.ngxLoader.start();
    console.log('serial number:', serialnumber);
    this.PumpService.getPumpDetails({pumpId: serialnumber, deletedFlag:'D'}).subscribe((response:any) => {
      console.log('TransformerDetails:', response);
      this.ngxLoader.stop();
      if(response.details.message.description.length > 0){
        this.openDialog(response.details.message);
      }
    })
  }


  deleteData(serialnumber:string) {
    console.log('SERIAL NUMBER:', serialnumber);
    this.ngxLoader.start();
    let dialogRef = this.matDialog.open(ConfirmationDailogComponent);
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.PumpService.deletePump({'action': 'delete','data':{'deleteFlag': 'D', 'serialnumber': serialnumber}}).subscribe((response:any) => {
          this.ngxLoader.stop();
          console.log('Response:', response);
          this.getpumpdata();
        })
      }
    });

  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  openDialog(transformerData? :any) {
    let action: string;

    let dialogRef: any;
    if(!transformerData) {
      transformerData='Add';

    }
    this.ngxLoader.start();
    this.PumpService.getTransformerIds().toPromise().then((response: any) => {
      console.log('Response:', transformerData);
      if(response.data.transformerId.length > 0){
        this.ngxLoader.stop();
        if(transformerData && transformerData !== "Add"){
          response.data.deviceId.push(transformerData.description[0].deviceId);
        }
        this.deviceMaster = response.data

        const dialogConfig = new MatDialogConfig();
      dialogConfig.data = "some data";
      dialogRef = this.matDialog.open(PumpaddeditComponent,{autoFocus: false, height:'600px',width:'650px'
      , data: {'transformerData' : transformerData, 'dropDownData' : this.deviceMaster}}  );

      dialogRef.afterClosed().subscribe((response) => {
        console.log('Close MODAL');

        this.getpumpdata();
      })
    }
    })


  }

}
